const updateDeviceMatrix = (newDeviceGroup, currentDeviceList) => {
  const remainingGroups = currentDeviceList.filter((deviceGroup) => deviceGroup.workstationId !== newDeviceGroup.workstationId);
  const updatedGroups = [newDeviceGroup, ...remainingGroups];
  return updatedGroups;
};

class ConnectReducerHelperClass {
  removePrintJob(currentPrintJobs, requestId) {
    if (!currentPrintJobs) {
      return [];
    }

    const remainingJobs = currentPrintJobs.filter((job) => job.requestId !== requestId);
    return remainingJobs;
  }

  updateJobStatus(currentPrintJobs, requestId, status, error = null) {
    if (!currentPrintJobs) {
      return [];
    }

    const jobToUpdate = currentPrintJobs.find((job) => job.requestId === requestId);
    if (!jobToUpdate) {
      return [...currentPrintJobs];
    }
    jobToUpdate.status = status;
    if (error) {
      jobToUpdate.error = error;
    }

    const remainingJobs = this.removePrintJob(currentPrintJobs, requestId);
    return [...remainingJobs, jobToUpdate];
  }

  updatePrintersMatrix(newPrintersWorkstationId, newPrinters, currentPrintersMatrix, getPrintersError = null) {
    const newPrintersGroup = {
      workstationId: newPrintersWorkstationId,
      printers: newPrinters,
    };
    if (getPrintersError) {
      newPrintersGroup.getPrintersError = getPrintersError;
    }
    return updateDeviceMatrix(newPrintersGroup, currentPrintersMatrix);
  }

  updateScalesMatrix(newPrintersWorkstationId, newScales, currentScalesMatrix) {
    const newScalesGroup = {
      workstationId: newPrintersWorkstationId,
      scales: newScales,
    };
    return updateDeviceMatrix(newScalesGroup, currentScalesMatrix);
  }

  setWorkstationOnlineStatus(workstationId, workstations, isOnline) {
    const workstationToUpdate = workstations.find((workstation) => workstation.workstationId === workstationId);
    if (!workstationToUpdate) {
      return [...workstations];
    }

    const remainingWorkstations = workstations.filter((workstation) => workstation.workstationId !== workstationId);
    const updatedWorkstation = {
      ...workstationToUpdate,
      isOnline,
    };

    return [...remainingWorkstations, updatedWorkstation];
  }
}

export const ConnectReducerHelper = new ConnectReducerHelperClass();
